module.exports = __webpack_public_path__ + "static/media/circle_violet.3a2ec8a4.png";